var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bid-file-preview"},[_c('bid-file-preview-balance',{staticClass:"m-b-16"}),_c('bid-file-preview-history')],1)}
var staticRenderFns = []

export { render, staticRenderFns }